import React from 'react';
import { styled } from 'styletron-react';
import { useLang, type Lang } from '../i18n/publicEvents';

const Wrap = styled('div', {
  display: 'inline-flex',
  alignItems: 'center',
  backgroundColor: '#F3F3F3',
  borderRadius: '999px',
  padding: '3px',
  gap: '2px',
});

const Seg = styled('button', ({ $active, $color }: { $active: boolean; $color: string }) => ({
  border: 'none',
  cursor: 'pointer',
  padding: '5px 12px',
  borderRadius: '999px',
  fontSize: '13px',
  fontWeight: 600,
  fontFamily: 'inherit',
  lineHeight: 1,
  backgroundColor: $active ? ($color || '#111827') : 'transparent',
  color: $active ? '#fff' : '#6B7280',
  transition: 'background-color 0.15s ease, color 0.15s ease',
}));

const LANGS: Array<{ id: Lang; label: string }> = [
  { id: 'en', label: 'EN' },
  { id: 'es', label: 'ES' },
];

export const LanguageToggle: React.FC<{ color?: string }> = ({ color = '#111827' }) => {
  const { lang, setLang } = useLang();
  return (
    <Wrap>
      {LANGS.map(({ id, label }) => (
        <Seg key={id} $active={lang === id} $color={color} onClick={() => setLang(id)} aria-pressed={lang === id}>
          {label}
        </Seg>
      ))}
    </Wrap>
  );
};
